var m = require('mithril');
var layout = require('../layout/layout');
var locationDetailBrowser = require('./locationDetailBrowser');
const locationEventSummary = require('./locationEventSummary');
var permissionEditor = require('./permissions');

function handleComponentReuse(Component, args) {
  // Component reuse logic if needed
  // Can implement caching or a check to prevent re-creation
  return Component; // Return the component class (not an instance)
}

module.exports = {
  '/location': {
    onmatch: function(args) {
      // Assuming the locationDetailBrowser can handle null/undefined id for 'home'
      args.id = args.id || null;
      return handleComponentReuse(locationDetailBrowser, args);
    },
    render: function(vnode) {
      // Pass args to component instance here if needed
      return m(layout, m(vnode.tag, vnode.attrs));
    },
  },
  '/location/:id': {
    onmatch: function(args) {
      return handleComponentReuse(locationDetailBrowser, args);
    },
    render: function(vnode) {
      return m(layout, m(vnode.tag, vnode.attrs));
    },
  },
  '/location/:id/permissions': {
    onmatch: function(args) {
      return handleComponentReuse(permissionEditor, args);
    },
    render: function(vnode) {
      return m(layout, m(vnode.tag, vnode.attrs));
    },
  },
  '/location/:id/eventsummary': {
    onmatch: function(args) {
      return handleComponentReuse(locationEventSummary, args);
    },
    render: function(vnode) {
      return m(layout, m(vnode.tag, vnode.attrs));
    },
  }
};